import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Scroll from 'react-scroll';

import './OptionListMultipleHeading.scss';

export default function OptionListMultipleHeading(props) {
  const { valid, list: { min, max, options = [] } = {}, t } = props;
  const isMinMax = min && max;
  const isNotMinMax = !min && !max;
  const isOnlyMin = min && !max;
  const isOnlyMax = !min && max;
  const isMinMaxEqual = min === max;
  const headingRef = useRef(null);
  const componentClass = classnames('c-option-list-multiple-heading', {
    'c-option-list-multiple-heading--error': !valid,
  });

  if (!valid) {
    Scroll.animateScroll.scrollTo(headingRef?.current?.offsetTop);
  }

  const getMinMaxMessage = () => {
    if (isMinMaxEqual) {
      return t(
        max === 1
          ? 'event.purchase.option-list-multiple.equal-single'
          : 'event.purchase.option-list-multiple.equal-plural',
        {
          0: max,
        },
      );
    }

    return t('event.purchase.choose.product.option.multiple.max.and.min', {
      0: min,
      1: max,
    });
  };

  return (
    <h5 ref={headingRef} className={componentClass}>
      {isMinMax && getMinMaxMessage()}
      {isNotMinMax &&
        t('event.purchase.choose.product.option.multiple', {
          0: options.length,
        })}
      {isOnlyMin &&
        t('event.purchase.choose.product.option.multiple.min', {
          0: min,
        })}
      {isOnlyMax &&
        t('event.purchase.choose.product.option.multiple.max', {
          0: max,
        })}
    </h5>
  );
}

OptionListMultipleHeading.propTypes = {
  valid: PropTypes.bool,
  list: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
    options: PropTypes.array,
  }),
  t: PropTypes.func,
};
